import { useMemo } from 'react';
import { CanvasSection } from '../../sweep-canvas/canvas-types';

export const useCalculateSectionNodes = ({ funnelMap }: { funnelMap: FunnelMap }) => {
  return useMemo(() => {
    const nodes: CanvasSection[] = [];

    // Sections are always visible if they exist
    if (!funnelMap.sections) {
      return { nodes };
    }

    // Convert sections to canvas sections
    Object.entries(funnelMap.sections).forEach(([id, section]) => {
      const canvasSection: CanvasSection = {
        nodeType: 'section',
        id: id,
        name: section.name,
        color: section.backgroundColor,
        width: section.width,
        height: section.height,
        xyPosition: section.xyPosition,
      };

      nodes.push(canvasSection);
    });

    return { nodes };
  }, [funnelMap.sections]);
};
